import * as React from 'react';
import { View } from 'react-native';
import { ViewStyle } from 'react-native';
import colors from '../../constants/colors';
import { Section } from '../user/UserItemCell';

const DisputeSectionBar = ({
  style,
  sortedBy,
  onClick,
}: {
  style?: ViewStyle;
  sortedBy?: string;
  onClick: (newSort: string) => void;
}) => {
  return (
    <View
      style={[
        {
          height: 60,
          paddingHorizontal: 10,

          borderWidth: 1,
          borderColor: colors.borderColor,
          borderRadius: 10,
          // @ts-ignore
          cursor: 'pointer',
          flexDirection: 'row',
          backgroundColor: colors.white,
          marginBottom: 10,
        },

        style,
      ]}
    >
      <Section
        label="User's email"
        withHover
        sorted={sortedBy === 'email'}
        onClick={
          () =>
            alert(
              'Must enable sorting by user email in the backend! 🙏',
            ) /** () => onClick('state') */
        }
      />
      <Section
        label="User's name"
        withHover
        sorted={sortedBy === 'firstName'}
        onClick={
          () =>
            alert(
              'Must enable sorting by user name in the backend! 🙏',
            ) /** () => onClick('state') */
        }
      />
      <Section
        label="State"
        withHover
        sorted={sortedBy === 'isResolved'}
        onClick={
          () =>
            alert(
              'Must enable sorting by state in the backend! 🙏',
            ) /** () => onClick('state') */
        }
      />
      <Section
        label="Trainer's name"
        withHover
        sorted={sortedBy === 'firstName'}
        onClick={
          () =>
            alert(
              "Must enable sorting by trainer's name in the backend! 🙏",
            ) /** () => onClick('state') */
        }
      />
      <Section
        label="Created at"
        withHover
        sorted={sortedBy === 'createdAt'}
        onClick={() => onClick('createdAt')}
      />
    </View>
  );
};

export default DisputeSectionBar;
